module.exports = __webpack_public_path__ + "static/media/Logo.8999996f.svg";